$('.js-icon-block-mobile-handle').on('click', function () {
  $(this)
    .closest('.icon-block')
    .toggleClass('mobile-active')
    .find('.js-icon-block-mobile-container')
    .stop()
    .slideToggle()
})
